import React from "react";
import { any, bool, oneOf } from "prop-types";
import './styles.scss';

const NavDropdownMenu = ({ children = null, nested = false, menuPlacement = 'right', className }) => {
  return (
    <ul className={`${className ? className: 'nav-dropdown-menu'}  p-0 ${nested ? '-nested' : ''} ${ menuPlacement }`}>
      {children}
    </ul>
  )
};

NavDropdownMenu.propTypes = {
  children: any,
  nested: bool,
  menuPlacement: oneOf(['left', 'right'])
};



export default NavDropdownMenu;
